let maskPlaceholder = '?+7 (999) 999-99-99';

$('.js-mask').each(function (index, element) {
  var _this = $(element);

  if (_this.data('mask')) {
    maskPlaceholder = _this.data('mask');
  }

  _this.mask(maskPlaceholder);
});

$('.js-date').mask('99.99');

// $('.js-mask').on('blur change', function (event) {
//   var _this = $(event.currentTarget);

//   setTimeout(function () {
//     _this.valid();
//   }, 100);
// });

$(document).on('keydown', '.js-mask', function (event) {
  if (event.which === 32) return false;
});
